<div class="logs-container">
  <div class="manage-kql-link">
    <a href="#kql-queries" class="btn btn-outline-primary" data-toggle="tab">
      Manage KQL Query Examples →
    </a>
  </div>
  <form [formGroup]="form" (ngSubmit)="fetchLogs()" class="form-grid">
    <div class="form-group">
      <label for="logs-query">KQL Query</label>
      <textarea
        id="logs-query"
        class="form-control"
        formControlName="query"
        rows="4"
        placeholder="Enter KQL query"
        [ngClass]="{ 'is-invalid': form.get('query')?.invalid && form.get('query')?.touched }"
      ></textarea>
      <div class="invalid-feedback" *ngIf="form.get('query')?.invalid && form.get('query')?.touched">
        Query is required.
      </div>
    </div>

    <div class="form-group">
      <label for="lookback">Lookback Window</label>
      <select id="lookback" class="form-control" formControlName="lookbackMinutes">
        <option *ngFor="let option of lookbackOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <div class="actions">
      <button type="submit" class="btn btn-primary" [disabled]="isLoading">
        {{ isLoading ? "Loading..." : "Run Query" }}
      </button>
    </div>
  </form>

  <div *ngIf="errorMessage" class="alert alert-danger mt-3">
    {{ errorMessage }}
  </div>

  <div class="table-responsive mt-3" *ngIf="!isLoading && logs.length > 0">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th *ngFor="let column of columns; trackBy: trackByColumn">
            {{ column }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of logs; trackBy: trackByRow">
          <td *ngFor="let column of columns; trackBy: trackByColumn" 
              [class.message-column]="column.toLowerCase() === 'message' || column.toLowerCase() === 'customdimensions'">
            {{ formatValue(row[column]) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="mt-3" *ngIf="!isLoading && logs.length === 0 && !errorMessage">
    <em>No results returned for the current query window.</em>
  </div>
</div>

